import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import StockEntryTable from './StockEntryTable';
import { incomingStockService } from '../services/incomingStockService';
import auth, { get, messageDialog, post } from '../../js/auth';
import './IncomingStockModal.css';
import $ from 'jquery';

class IncomingStockModal extends Component {
        handleClearSupplier = () => {
            this.handleSupplierAutoCompleteChange([]);
        };
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                id: '',
                supplier: null,
                date: new Date(),
                time: new Date(),
                invoice_id: '',
                delivery_note_id: '',
                entries: [],
                draft: true
            },
            validationErrors: [],
            isSaving: false,
            isDraft: false,
            autoImport: false,
            autoCommit: false,
            rawTextData: '',
            regexpPattern: '',
            loading: false,
            dropdownLoaded: false,
            lastLoadedStockId: null,
            maximized: sessionStorage.getItem('incomingStockModalMaximized') === 'true',
            supplierOptions: [],
            supplierLoading: false
        };
        this.entryTableRef = React.createRef();
    }

    runValidationAfterFormChange = (stateUpdate, onAfterState = null) => {
        this.setState(stateUpdate, () => {
            this.validateForm();
            if (onAfterState) {
                onAfterState();
            }
        });
    };
    handleSupplierSearch = async (query) => {
        this.setState({ supplierLoading: true });
        try {
            // Simulate API call, replace with actual supplier search
            const suppliers = await incomingStockService.getSuppliers(query);
            this.setState({ supplierOptions: suppliers || [], supplierLoading: false });
        } catch (error) {
            this.setState({ supplierLoading: false });
        }
    };

    handleSupplierAutoCompleteChange = async (selected) => {
        const supplier = selected && selected.length > 0 ? selected[0] : null;
        this.handleInputChange('supplier', supplier);
        this.setState({
            autoImport: supplier?.processInvoices ?? true,
            autoCommit: supplier?.autoCommit ?? false
        }, () => this.validateForm());

        // --- Migrated logic from handleSupplierChange ---
        // Autopopulate entries if empty or all counts are zero
        const { formData } = this.state;
        const entriesEmpty = !formData.entries || formData.entries.length === 0;
        const allCountsZero = formData.entries && formData.entries.every(entry => !entry.count || Number(entry.count) === 0);
        if (supplier && (entriesEmpty || allCountsZero)) {
            // Fetch supplier codes (simulate API call)
            const data = await this.getSupplierCodes(supplier.id);
            let vat_category = undefined;
            let store = undefined;
            let firstEntry = null;
            const newEntries = [];
            data.filter(a => a.menuItem)
                .sort((a, b) => a.menuItem && a.menuItem.name.localeCompare(b.menuItem.name))
                .forEach(entry => {
                    if (entry.menuItem.type === "deleted") return;
                    if (!entry.menuItem.defaultInventoryItem) return;
                    //eslint-disable-next-line eqeqeq
                    if (!entry.menuItem.availableQuantities.find(q => q.inventoryItem && q.quantity == entry.quantity)) return;
                    // Prepare entry
                    entry.code = "";
                    entry.multiplicator = 1;
                    entry.count = undefined;
                    entry.expiryDate = null;
                    entry.net_price = undefined;
                    entry.brutto_price = undefined;
                    entry.id = undefined;
                    newEntries.push(entry);
                    var v = entry.vatCategory.id + ";" + entry.vatCategory.percent;
                    if (vat_category === undefined || vat_category === v) {
                        vat_category = v;
                    } else {
                        vat_category = null;
                    }
                    if (store === undefined || Number(store) === entry.store.id) {
                        store = entry.store.id;
                    } else {
                        store = null;
                    }
                    if (firstEntry === null) firstEntry = entry;
                });
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    entries: newEntries
                }
            }), () => {
                // Optionally focus first entry's count input if you have refs
            });
        }
    };

    handleAutoImportChange = (e) => {
        const checked = e.checked;
        this.setState({ autoImport: checked }, () => this.validateForm());
        const supplier = this.state.formData.supplier;
        if (supplier && supplier.id) {
            // Update supplier object in formData
            const updatedSupplier = { ...supplier, processInvoices: checked };
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    supplier: updatedSupplier
                }
            }), () => this.validateForm());
            // Send both properties
            post(`adminService/${localStorage.restaurantSelected}/modifySupplier`, {
                id: supplier.id,
                processInvoices: checked,
                autoCommit: supplier.autoCommit
            });
        }
    }

    handleAutoCommitChange = (e) => {
        const checked = e.checked;
        this.setState({ autoCommit: checked }, () => this.validateForm());
        const supplier = this.state.formData.supplier;
        if (supplier && supplier.id) {
            // Update supplier object in formData
            const updatedSupplier = { ...supplier, autoCommit: checked };
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    supplier: updatedSupplier
                }
            }), () => this.validateForm());
            // Send both properties
            post(`adminService/${localStorage.restaurantSelected}/modifySupplier`, {
                id: supplier.id,
                processInvoices: supplier.processInvoices,
                autoCommit: checked
            });
        }
    }

    componentDidMount() {
        this.loadDropdownData();
        
        // Check for hash-based routing to open specific stock entry
        this.handleHashRouting();
        
        // Initialize form data after mounting
        const initialFormData = this.initializeFormData();
        this.setState({ formData: initialFormData });
        
        // Listen for hash changes
        window.addEventListener('hashchange', this.handleHashChange);
        
        // Update hash if modal is visible and has a stock on mount
        if (this.props.isVisible && this.props.stock && this.props.stock.id) {
            this.updateHashForStock(this.props.stock.id, this.props.mode);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('hashchange', this.handleHashChange);
    }

    handleHashChange = () => {
        this.handleHashRouting();
    }

    handleHashRouting = () => {
        const hash = window.location.hash;
        
        // Check if hash matches pattern: stockManagementMenu/incomingStocks/[id]
        const hashMatch = hash.match(/stockManagementMenu\/incomingStocksNew\/(\d+)/);
        if (hashMatch) {
            const stockId = parseInt(hashMatch[1]);
            this.loadStockFromHash(stockId);
        }
    }

    loadStockFromHash = async (stockId) => {
        // Prevent reloading the same stock multiple times
        if (this.state.lastLoadedStockId === stockId) {
            return;
        }
        try {
            // Set loading state
            this.setState({ loading: true, lastLoadedStockId: stockId });
            // Call parent method to open the modal and load the stock
            if (this.props.onOpenStock) {
                this.props.onOpenStock(stockId);
            }
        } catch (error) {
            console.error('Error loading stock from hash:', error);
            // Could show an error message here
        } finally {
            this.setState({ loading: false });
        }
    }

    updateHashForStock = (stockId, mode = null) => {
        if (stockId) {
            const currentMode = mode || this.props.mode || 'view';
            const newHash = `#stockManagementMenu/incomingStocksNew/${stockId}`;
            
            if (window.location.hash !== newHash) {
                window.location.hash = newHash;
            } else {
            }
        } else {
        }
    }

    clearHash = () => {
        if (window.location.hash.includes('incomingStocks')) {
            window.location.hash = '#stockManagementMenu/incomingStocksNew';
        }
    }

    componentDidUpdate(prevProps, prevState) {
        
        const stockChanged = prevProps.stock !== this.props.stock;
        const modeChanged = prevProps.mode !== this.props.mode;
        const visibilityChanged = prevProps.isVisible !== this.props.isVisible;
        const formDataChanged = prevState.formData !== this.state.formData;
        const supplierFlagsChanged = prevState.autoImport !== this.state.autoImport || prevState.autoCommit !== this.state.autoCommit;

        // Only load dropdown data once when modal becomes visible
        if (visibilityChanged && this.props.isVisible && !this.state.dropdownLoaded) {
            this.loadDropdownData();
            this.setState({ dropdownLoaded: true });
        }

        // Always reinitialize formData and update hash if modal is visible and any relevant prop changes
        if (this.props.isVisible && (stockChanged || modeChanged || visibilityChanged)) {
            this.setState({ formData: this.initializeFormData() });

            if (this.props.stock && this.props.stock.id) {
                this.updateHashForStock(this.props.stock.id, this.props.mode);
            }
        } else if (!this.props.isVisible && visibilityChanged) {
            // Clear hash when modal is closed
            this.clearHash();
        }

        if (formDataChanged || supplierFlagsChanged) {
            const nextValidation = incomingStockService.validateStock(this.state.formData || {});
            const nextErrors = nextValidation.errors || [];
            const currentErrors = this.state.validationErrors || [];
            if (JSON.stringify(currentErrors) !== JSON.stringify(nextErrors)) {
                this.setState({ validationErrors: nextErrors });
            }
        }
    }

    initializeFormData = () => {
        const { stock, mode } = this.props;
        
        let formData;
        
        if (mode === 'new') {
            formData = {
                id: '',
                supplier: null,
                date: new Date(),
                time: new Date(),
                invoice_id: '',
                delivery_note_id: '',
                entries: stock?.entries || [],
                draft: true
            };
            // Set autoImport and autoCommit from supplier if available
            const supplier = stock?.supplier || null;
            this.setState({
                autoImport: supplier?.processInvoices ?? true,
                autoCommit: supplier?.autoCommit ?? false
            });
        } else if (stock) {
            formData = {
                id: stock.id || '',
                supplier: stock.supplier || null, // This should be the full supplier object
                date: stock.date ? new Date(stock.date) : new Date(),
                time: stock.date ? new Date(stock.date) : new Date(),
                invoice_id: stock.invoice_id || '',
                delivery_note_id: stock.delivery_note_id || '',
                entries: stock.entries ? stock.entries.map(entry => { return { ...entry, vatCategory: { id: entry.vatCategory.id + ";" + entry.vatCategory.percent } } }) : [],
                draft: stock.draft || false
            };
            // Set autoImport and autoCommit from supplier if available
            const supplier = stock.supplier || null;
            this.setState({
                autoImport: supplier?.processInvoices ?? true,
                autoCommit: supplier?.autoCommit ?? false
            });
        } else {
            formData = this.state?.formData || {
                id: '',
                supplier: null,
                date: new Date(),
                time: new Date(),
                invoice_id: '',
                delivery_note_id: '',
                entries: [],
                draft: true
            };
        }
        
        return formData;
    }

    loadDropdownData = async () => {
        const { suppliers, stores, vatCategories, quantityTypes, products, dispatch } = this.props;
        let needLoad = false;
        if (!suppliers || suppliers.length === 0) needLoad = true;
        if (!stores || stores.length === 0) needLoad = true;
        if (!vatCategories || vatCategories.length === 0) needLoad = true;
        if (!quantityTypes || quantityTypes.length === 0) needLoad = true;
        if (!products || products.length === 0) needLoad = true;

        if (needLoad) {
            try {
                const [suppliersRes, storesRes, vatRes, qtyRes, productsRes] = await Promise.all([
                    incomingStockService.getSuppliers(),
                    incomingStockService.getStores(),
                    incomingStockService.getVATCategories(),
                    incomingStockService.getQuantityTypes(),
                    incomingStockService.getMenuItems()
                ]);
                dispatch({ type: 'setSuppliers', suppliers: suppliersRes || [] });
                dispatch({ type: 'setStores', stores: storesRes || [] });
                dispatch({ type: 'setVatCategories', vatCategories: vatRes || [] });
                dispatch({ type: 'setQuantityTypes', quantityTypes: qtyRes || [] });
                dispatch({ type: 'setMenuItems', menuItems: (productsRes || []).flatMap(item => item.items ? item.items : item) });
            } catch (error) {
                console.error('IncomingStockModal - Failed to load dropdown data:', error);
            }
        } else {
        }
        this.setState({ dropdownLoaded: true });
        if (this.loadDropdownDataTimeout) {
            return;
        }
        this.loadDropdownDataTimeout = setTimeout(() => {
            this.loadDropdownDataTimeout = null;
        }, 500);
    }

    handleInputChange = (field, value) => {
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [field]: value
            }
        }), () => this.validateForm());
    }

    handleSupplierChange = async (e) => {
        const { suppliers } = this.props;
        const selectedSupplier = suppliers.find(s => s.id === e.value);
        this.handleInputChange('supplier', selectedSupplier);
        // Update autoImport and autoCommit from supplier properties
        this.setState({
            autoImport: selectedSupplier?.processInvoices ?? true,
            autoCommit: selectedSupplier?.autoCommit ?? false
        }, () => this.validateForm());

        // Autopopulate entries if empty or all counts are zero
        const { formData } = this.state;
        const entriesEmpty = !formData.entries || formData.entries.length === 0;
        const allCountsZero = formData.entries && formData.entries.every(entry => !entry.count || Number(entry.count) === 0);
        if (selectedSupplier && (entriesEmpty || allCountsZero)) {
            // Fetch supplier codes (simulate API call)
            const data = await this.getSupplierCodes(selectedSupplier.id);
            let vat_category = undefined;
            let store = undefined;
            let firstEntry = null;
            const newEntries = [];
            data.filter(a => a.menuItem)
                .sort((a, b) => a.menuItem && a.menuItem.name.localeCompare(b.menuItem.name))
                .forEach(entry => {
                    if (entry.menuItem.type === "deleted") return;
                    if (!entry.menuItem.defaultInventoryItem) return;
                    if (!entry.menuItem.availableQuantities.find(q => q.inventoryItem && q.quantity == entry.quantity)) return;
                    // Prepare entry
                    entry.code = "";
                    entry.multiplicator = 1;
                    entry.count = undefined;
                    entry.expiryDate = null;
                    entry.net_price = undefined;
                    entry.brutto_price = undefined;
                    entry.id = undefined;
                    newEntries.push(entry);
                    var v = entry.vatCategory.id + ";" + entry.vatCategory.percent;
                    if (vat_category === undefined || vat_category === v) {
                        vat_category = v;
                    } else {
                        vat_category = null;
                    }
                    if (store === undefined || Number(store) === entry.store.id) {
                        store = entry.store.id;
                    } else {
                        store = null;
                    }
                    if (firstEntry === null) firstEntry = entry;
                });
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    entries: newEntries
                }
            }), () => {
                // Optionally focus first entry's count input if you have refs
            });
        }
    }

    // Simulate API call for supplier codes
    getSupplierCodes = async (supplierId) => {
        // Replace with real API call
        return await get(`adminService/${localStorage.restaurantSelected}/getSupplierCodes/${supplierId}`);
    }

    handleDateTimeChange = (field, value) => {
        this.setState(prevState => {
            const formData = { ...prevState.formData };
            
            if (field === 'date') {
                const currentTime = formData.time || new Date();
                const newDate = new Date(value);
                newDate.setHours(currentTime.getHours(), currentTime.getMinutes());
                formData.date = newDate;
            } else if (field === 'time') {
                const currentDate = formData.date || new Date();
                const newTime = new Date(value);
                const newDate = new Date(currentDate);
                newDate.setHours(newTime.getHours(), newTime.getMinutes());
                formData.date = newDate;
                formData.time = newTime;
            }
            
            return { formData };
        }, () => this.validateForm());
    }

    handleEntriesChange = (entries) => {
        this.handleInputChange('entries', entries);
        
        // Clear modal-level validation errors when entries change
        // This ensures the save button updates properly when errors are fixed
        //this.setState({ validationErrors: [] });
    }

    validateForm = () => {
        const { formData } = this.state;
        const validation = incomingStockService.validateStock(formData);
        
        this.setState({ validationErrors: validation.errors });
        
        return validation.isValid;
    }

    // Check if there are any validation errors in entries
    hasEntryValidationErrors = () => {
        const { formData } = this.state;
        if (!formData.entries || formData.entries.length === 0) {
            return false;
        }
        
        // Check each entry for validation errors
        const hasErrors = formData.entries.some(entry => {
            // Skip validation for entries with supplier code but no product (valid intermediate state)
            if (entry?.code && entry.code.trim() !== '' && (!entry?.menuItem || !entry.menuItem.id)) {
                return false;
            }
            
            // Skip validation for ignored entries
            if (entry?.ignored) {
                return false;
            }
            
            const entryValidation = incomingStockService.validateEntry(entry);
            return !entryValidation.isValid;
        });

        return hasErrors;
    }

    handleSave = async () => {
        if (!this.validateForm()) {
            return;
        }

        this.setState({ isSaving: true });

        try {
            const { formData, isDraft } = this.state;
            
            // Prepare the data for submission
            const stockData = {
                ...formData,
                date: formData.date.getTime(),
                draft: isDraft,
                entries: formData.entries.map(entry => ({
                    ...entry,
                    id: (typeof entry.id === 'number' && !isNaN(entry.id)) ? entry.id : null,
                    count: incomingStockService.parseNumber(entry.count),
                    net_unit_price: incomingStockService.parseNumber(entry.net_unit_price),
                    brutto_unit_price: incomingStockService.parseNumber(entry.brutto_unit_price),
                    net_price: incomingStockService.parseNumber(entry.net_price),
                    brutto_price: incomingStockService.parseNumber(entry.brutto_price),
                    // Preserve ignored status
                    ignored: entry.ignored || false,
                    vatCategory: (() => {
                        if (!entry.vatCategory) return null;
                        if (typeof entry.vatCategory.id === 'string' && entry.vatCategory.id.includes(';')) {
                            const [id, percent] = entry.vatCategory.id.split(';');
                            return { id, percent: percent ? Number(percent) : undefined };
                        }
                        return { id: entry.vatCategory.id };
                    })(),
                }))
            };

            await this.props.onSave(stockData);
            this.setState({ isSaving: false });
        } catch (error) {
            console.error('Save failed:', error);
            this.setState({ 
                isSaving: false,
                validationErrors: ['Save failed: ' + error.message]
            });
        }
    }

    handleClose = () => {
        this.setState({
            formData: this.initializeFormData(),
            validationErrors: [],
            isSaving: false,
            dropdownLoaded: false, // Reset so dropdowns reload next open
            lastLoadedStockId: null // Reset loaded stockId on close
        });
        this.props.onClose();
    }

    handlePrint = () => {
        window.print();
    }

    handleRegexpExecute = () => {
        // Implementation for regexp parsing from raw text data
        const { rawTextData, regexpPattern } = this.state;
        
        if (!rawTextData || !regexpPattern) {
            return;
        }

        try {
            const regex = new RegExp(regexpPattern, 'gm');
            const matches = rawTextData.match(regex);
            
            if (matches) {
                // Process matches into entries
                const newEntries = matches.map((match, index) => ({
                    id: `temp-${Date.now()}-${index}`,
                    supplier_code: '',
                    count: 1,
                    menuItem: null,
                    store: null,
                    vatCategory: null,
                    quantityType: null,
                    net_unit_price: 0,
                    brutto_unit_price: 0,
                    net_price: 0,
                    brutto_price: 0,
                    expiry_date: null
                }));
                
                this.handleEntriesChange([...this.state.formData.entries, ...newEntries]);
            }
        } catch (error) {
            console.error('Regexp execution failed:', error);
        }
    }

    queryInvoiceData = async () => {
        const { formData } = this.state;

        if (this.props.online_szamla === false) {
            messageDialog(I18n.t("local.information"), I18n.t("admin_local.online_szamla_feature"));
            return;
        }

        if (!formData.invoice_id || formData.invoice_id.trim() === '') {
            messageDialog(I18n.t("local.information"), I18n.t("admin_local.invoice_not_found"));
            return;
        }

        try {
            this.setState({ loading: true });
            
            // Call the invoice query API
            const url = `adminService/${localStorage.restaurantSelected}/queryInvoiceData`;
            const response = await post(url, formData.invoice_id);
            
            // Find matching supplier by name
            const suppliers = this.props.suppliers;
            let supplierId = null;
            if (Array.isArray(suppliers)) {
                supplierId = suppliers.find(s => 
                    s.name && response.invoiceHead.supplierInfo.supplierName &&
                    s.name.toLowerCase() === response.invoiceHead.supplierInfo.supplierName.toLowerCase()
                )?.id;
            } else {
                console.warn('Suppliers is not defined or not an array in queryInvoiceData');
            }

            // Update supplier if found
            if (supplierId) {
                const selectedSupplier = suppliers.find(s => s.id === supplierId);
                this.setState(prevState => ({
                    formData: {
                        ...prevState.formData,
                        supplier: selectedSupplier
                    }
                }));
            }
            
            // Process invoice lines into entries
            const vatCategories = this.props.vatCategories;
            const entries = response.invoiceLines.lines
                .filter(line => (line.unitPriceHUF || line.unitPrice || 0) > 0)
                .map((line, index) => {
                    // Find matching VAT category
                    const vatPercentage = (line.lineAmountsNormal || line.lineAmountsSimplified)?.lineVatRate?.vatPercentage * 100;
                    const vatCategory = Array.isArray(vatCategories) ? vatCategories.find(v => {
                        // Extract percentage from VAT category ID format "id;percentage"
                        const parts = String(v.id).split(';');
                        const categoryPercent = parts.length > 1 ? parseFloat(parts[1]) : v.percent;
                        return categoryPercent === vatPercentage;
                    }) : null;
                    
                    const multiplicator = 1;
                    const original_quantity = line.quantity;
                    const count = line.quantity;
                    
                    let net_price, brutto_price;
                    
                    if (line.lineAmountsSimplified) {
                        brutto_price = line.lineAmountsSimplified.lineGrossAmountSimplifiedHUF || line.lineAmountsSimplified.lineGrossAmountSimplified;
                        net_price = brutto_price * 100 / (100 + (vatCategory?.percent || 0));
                    } else {
                        net_price = line.lineAmountsNormal.lineNetAmountData.lineNetAmountHUF || line.lineAmountsNormal.lineNetAmountData.lineNetAmount;
                        brutto_price = net_price * (100 + (vatCategory?.percent || 0)) / 100;
                    }
                    
                    const net_unit_price = count !== 0 ? net_price / count : 0;
                    const brutto_unit_price = count !== 0 ? brutto_price / count : 0;
                    
                    return {
                        id: `invoice-${Date.now()}-${index}`,
                        code: line.lineDescription || '',
                        supplier_code: line.lineDescription || '',
                        multiplicator,
                        original_quantity,
                        count,
                        net_unit_price: incomingStockService.formatNumber(net_unit_price),
                        brutto_unit_price: incomingStockService.formatNumber(brutto_unit_price),
                        net_price: incomingStockService.formatNumber(net_price),
                        brutto_price: incomingStockService.formatNumber(brutto_price),
                        vatCategory,
                        ignored: false,
                        menuItem: null, // Will need to be mapped by user
                        store: null,
                        quantityType: null,
                        expiry_date: null
                    };
                });
            
            // Clear existing entries and replace with new invoice entries
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    entries: entries // Replace all entries with invoice entries
                }
            }), () => {
                // After entries are set, trigger supplier code processing for each entry
                // This mimics the original implementation's .supplier_code.trigger("change")
                this.processEntriesSupplierCodes();
            });
            
            
        } catch (error) {
            auth.ajaxError = false;
            console.error('Invoice query failed:', error);
            
            if (error.status === 404) {
                messageDialog(I18n.t("local.information"), I18n.t("admin_local.invoice_not_found"));
            } else {
                messageDialog(I18n.t("local.error"), I18n.t("admin_local.failed_to_query_invoice_data") + ': ' + (error.message || I18n.t("local.unknown_error")));
            }
        } finally {
            this.setState({ loading: false });
        }
    }

    processEntriesSupplierCodes = async () => {
        // Process each entry with a supplier code to get default VAT category and other data
        // This mimics the original implementation's supplier code change behavior
        const { formData } = this.state;
        const { supplier } = formData;
        
        if (!supplier || !supplier.id) {
            return;
        }

        const updatedEntries = [...formData.entries];
        let hasUpdates = false;

        for (let i = 0; i < updatedEntries.length; i++) {
            const entry = updatedEntries[i];
            
            if (entry.code && entry.code.trim() !== '') {
                try {
                    
                    // Call the API to get default product data for this supplier code
                    const url = `adminService/${localStorage.restaurantSelected}/getDefaultProductForSupplierCode/${supplier.id}`;
                    const response = await post(url, entry.code);
                    
                    if (response && response.length > 0) {
                        const defaultData = response[0];
                       
                        
                        // Update store if provided
                        if (defaultData.store) {
                            const store = this.props.stores.find(s => s.id === defaultData.store);
                            if (store) {
                                updatedEntries[i] = { ...updatedEntries[i], store };
                                hasUpdates = true;
                            }
                        }
                        
                        // Update menu item if provided and not already set
                        if (defaultData.menuItem && !entry.menuItem) {
                            const menuItem = this.props.flatProducts.find(p => p.id === defaultData.menuItem);
                            if (menuItem) {
                                updatedEntries[i] = { ...updatedEntries[i], menuItem };
                                hasUpdates = true;
                            }
                        }
                        
                        // Update multiplicator if provided
                        if (defaultData.multiplicator) {
                            updatedEntries[i] = { ...updatedEntries[i], multiplicator: defaultData.multiplicator };
                            hasUpdates = true;
                        }
                        
                        // Update quantity and type if provided
                        if (defaultData.quantity && defaultData.quantityType) {
                            updatedEntries[i] = { 
                                ...updatedEntries[i], 
                                quantity: defaultData.quantity,
                                quantityType: defaultData.quantityType
                            };
                            hasUpdates = true;
                        }
                        
                    } else {
                    }
                    
                } catch (error) {
                    console.error(`Failed to get default data for supplier code '${entry.code}':`, error);
                    // Continue with next entry even if this one fails
                }
            }
        }
        
        // Update state if any entries were modified
        if (hasUpdates) {
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    entries: updatedEntries
                }
            }));
        }
    }

    handleMaximize = (maximized) => {
        sessionStorage.setItem('incomingStockModalMaximized', maximized ? 'true' : 'false');
        this.setState({ maximized });
    }

    render() {
        // Use Redux props for dropdowns
        const { suppliers, stores, vatCategories, quantityTypes, products } = this.props;
        const { mode, isVisible } = this.props;
        const { 
            formData, 
            validationErrors, 
            isSaving, 
            isDraft,
            autoImport,
            autoCommit,
            rawTextData,
            regexpPattern,
            maximized
        } = this.state;


        const dialogTitle = I18n.t('admin_local.incomingStock');

        // Check for validation errors
        const hasModalErrors = validationErrors.length > 0;
        const hasEntryErrors = this.hasEntryValidationErrors();
        const hasAnyErrors = hasModalErrors || hasEntryErrors;
        
        const dialogFooter = (
            <div className="modal-footer">
                <button 
                    type="button" 
                    className="hidden btn btn-primary btn"
                    onClick={() => $('.input-group.text-input').show()}
                >
                    Text Input
                </button>
                <Button 
                    label={I18n.t('admin_local.close')} 
                    icon="pi pi-times" 
                    onClick={this.handleClose}
                    className="p-button-secondary btn"
                />
                <div style={{ flexGrow: 1 }} />
                <div className="draft-toggle">
                    <Checkbox
                        inputId="draft"
                        checked={isDraft}
                        onChange={(e) => this.setState({ isDraft: e.checked })}
                    />
                    <label htmlFor="draft" style={{ paddingRight: '20px' }}>
                       {I18n.t("admin_local.draft")}
                    </label>
                </div>
                <Button 
                    label={hasAnyErrors ? I18n.t('admin_local.cannotSave') : I18n.t('admin_local.save')}
                    icon={hasAnyErrors ? "pi pi-exclamation-triangle" : "pi pi-check"}
                    onClick={this.handleSave}
                    className={hasAnyErrors ? "p-button-danger btn" : "p-button-primary btn"}
                    disabled={isSaving || hasAnyErrors}
                    loading={isSaving}
                    tooltip={hasAnyErrors ? I18n.t('admin_local.fixValidationErrors') : ""}
                    tooltipOptions={{ position: 'top' }}
                />
            </div>
        );

        return (
            <Dialog
                id="IncomingStocksNew"
                visible={isVisible}
                closable={true}
                closeOnEscape={true}
                style={maximized ? { width: '100vw', height: '100vh' } : { width: '90vw', height: '90vh' }}
                header={
                    <div className="modal-header-expanded">
                        {/* Header Title Bar */}
                        <div className="modal-title-bar browser-only">
                            <h2 className="modal-title">{dialogTitle}</h2>
                            <div style={{ flexGrow: 1 }} />
                            <Button
                                icon="pi pi-print"
                                className="p-button-rounded p-button-text"
                                onClick={this.handlePrint}
                            />
                        </div>
                        
                        {/* Form Fields Section */}
                        <div className="modal-form-section">
                            <input 
                                type="hidden" 
                                value={formData.id || ''} 
                            />
                            
                            {/* First Row: Supplier, Checkboxes, and Date/Time */}
                            <div className="form-row">
                                <div className="form-field supplier-field">
                                    <label className="field-label">{I18n.t('admin_local.supplier')}</label>
                                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                        <AsyncTypeahead
                                            id="SupplierAutoComplete"
                                            labelKey="name"
                                            minLength={2}
                                            isLoading={this.state.supplierLoading}
                                            onSearch={this.handleSupplierSearch}
                                            options={this.state.supplierOptions}
                                            placeholder={I18n.t('admin_local.select_a_supplier')}
                                            onChange={this.handleSupplierAutoCompleteChange}
                                            selected={formData.supplier ? [formData.supplier] : []}
                                            renderMenuItemChildren={(option) => (
                                                <span key={option.id}>{option.name}</span>
                                            )}
                                            className="supplier-dropdown"
                                            style={{ flex: 1, minWidth: 0, width: '100%' }}
                                        />
                                        <Button
                                            icon="pi pi-times"
                                            className="p-button-rounded p-button-text"
                                            style={{ marginLeft: 8 }}
                                            onClick={this.handleClearSupplier}
                                            tooltip={I18n.t('admin_local.clear')}
                                        />
                                    </div>
                                </div>
                                
                                {/* Supplier-related checkboxes */}
                                <div className="form-field checkbox-field">
                                    <div className="supplier-checkboxes-horizontal">
                                        <div className="checkbox-item hide-print">
                                            <Checkbox
                                                inputId="autoimport"
                                                checked={autoImport}
                                                onChange={this.handleAutoImportChange}
                                            />
                                            <label htmlFor="autoimport" className="checkbox-label">
                                                {I18n.t('admin_local.auto_import_incoming_stocks')}
                                            </label>
                                        </div>
                                        
                                        <div className="checkbox-item hide-print">
                                            <Checkbox
                                                inputId="autocommit"
                                                checked={autoCommit}
                                                onChange={this.handleAutoCommitChange}
                                            />
                                            <label htmlFor="autocommit" className="checkbox-label">
                                                {I18n.t('admin_local.auto_commit_imcoming_stocks')}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="form-field date-field">
                                    <label className="field-label">{I18n.t('admin_local.date')}</label>
                                    <div className="date-time-container">
                                        <Calendar
                                            value={formData.date}
                                            onChange={(e) => this.handleDateTimeChange('date', e.value)}
                                            dateFormat="dd/mm/yy"
                                            showIcon
                                            className="date-picker"
                                        />
                                        <Calendar
                                            value={formData.time}
                                            onChange={(e) => this.handleDateTimeChange('time', e.value)}
                                            timeOnly
                                            showIcon
                                            className="time-picker"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Second Row: Invoice and Delivery Note */}
                            <div className="form-row">
                                <div className="form-field">
                                    <label className="field-label">{I18n.t('admin_local.invoice_id')}</label>
                                    <div className="input-button-group">
                                        <InputText
                                            value={formData.invoice_id}
                                            onChange={(e) => this.handleInputChange('invoice_id', e.target.value)}
                                                placeholder={I18n.t('admin_local.enter_invoice_id')}
                                            className="invoice-input"
                                        />
                                        <Button
                                            className="p-button-primary p-button-sm invoice-query-button"
                                            onClick={this.queryInvoiceData}
                                            tooltip={I18n.t('admin_local.query_invoice_data')}
                                        >
                                            <i className="icon-download"></i>
                                            <img style={{ height: '25px', marginLeft: '4px' }} src="img/e-szamla-logo.svg" alt="e-szamla" />
                                        </Button>
                                    </div>
                                </div>

                                <div className="form-field">
                                    <label className="field-label">{I18n.t('admin_local.delivery_note_id')}</label>
                                    <InputText
                                        value={formData.delivery_note_id}
                                        id="delivery_note_id"
                                        onChange={(e) => this.handleInputChange('delivery_note_id', e.target.value)}
                                            placeholder={I18n.t('admin_local.enter_delivery_note_id')}
                                        className="delivery-note-input"
                                    />
                                </div>
                            </div>
                            
                            {/* Hidden Raw Data and Regexp sections */}
                            <div className="hidden">
                                <span className="label">Raw data</span>
                                <textarea
                                    value={rawTextData}
                                    onChange={(e) => this.setState({ rawTextData: e.target.value })}
                                    style={{ marginBottom: '0rem' }}
                                />
                            </div>

                            <div className="hidden">
                                <Button
                                    label="Regexp execute"
                                    onClick={this.handleRegexpExecute}
                                    className="p-button-primary"
                                    style={{ minWidth: '170px' }}
                                />
                                <textarea
                                    value={regexpPattern}
                                    onChange={(e) => this.setState({ regexpPattern: e.target.value })}
                                    style={{ marginBottom: '0rem' }}
                                />
                            </div>
                        </div>
                    </div>
                }
                footer={dialogFooter}
                onHide={this.handleClose}
                modal
                maximizable
                maximized={!!maximized}
                onMaximize={() => this.handleMaximize(true)}
                onRestore={() => this.handleMaximize(false)}
            >
                <div className="incoming-stock-modal-content">
                    <datalist id="codes">
                        {/* Supplier codes would be populated here */}
                    </datalist>

                    {/* Entry Table - Full height */}
                    <div className="table-container">
                        <StockEntryTable
                            ref={this.entryTableRef}
                            entries={formData.entries}
                            onChange={this.handleEntriesChange}
                            suppliers={suppliers}
                            stores={stores}
                            vatCategories={vatCategories}
                            quantityTypes={quantityTypes}
                            products={products}
                            online_szamla={this.props.online_szamla}
                            flatProducts={this.props.flatProducts}
                        />
                    </div>
                </div>
            </Dialog>
        );
    }
}

// Helper to flatten menuCategories to menuItems
const flattenMenuItems = (menuCategories) => {
    if (!Array.isArray(menuCategories)) return [];
    let items = [];
    menuCategories.forEach(cat => {
        if (Array.isArray(cat.activeMenuItems)) {
            items = items.concat(cat.activeMenuItems);
        }
        if (Array.isArray(cat.activeMenuCategories)) {
            items = items.concat(flattenMenuItems(cat.activeMenuCategories));
        }
    });
    return items;
};


let lastMenuCategories = null;
let lastFlatProducts = [];
const mapStateToProps = (state) => {
    const menuCategories = state.rootReducer.menuCategories || [];
    if (menuCategories !== lastMenuCategories) {
        lastMenuCategories = menuCategories;
        lastFlatProducts = flattenMenuItems(menuCategories);
    }
    return {
        suppliers: state.rootReducer.suppliers || [],
        stores: state.rootReducer.stores || [],
        vatCategories: state.rootReducer.vatCategories || [],
        quantityTypes: state.rootReducer.quantityTypes || [],
        products: menuCategories,
        flatProducts: lastFlatProducts,
    };
};

export default connect(mapStateToProps)(IncomingStockModal);